<template>
  <router-view />
</template>

<script>
export default {
  name: 'redemptions-pages-container',
};
</script>
